<template>
  <div>
    <Headline
      :title="title"
      subtitle="El éxito está en los pequeños detalles"
      third-text="Ofrecemos calidad de servicio y tecnología avanzada"
      image="meetings"
    ></Headline>
    <Section image="meetings-1">
      <Card
        title="Gestionamos todos los servicios"
        size="lg"
        variant="list"
      >
        <ul>
          <li>Búsqueda, inspección y selección de emplazamientos</li>
          <li>Transporte (aéreo o terrestre)</li>
          <li>Alojamiento</li>
          <li>Servicio de bienvenida</li>
          <li>Asistencia in situ</li>
          <li>Servicio audiovisual</li>
          <li>Servicio de vídeo y fotografía</li>
          <li>Gestión de contratos con proveedores de servicios, reservas hoteleras, catering, entre otros</li>
          <li>Ofertas</li>
          <li>Branding, Banners, Insignias</li>
          <li>Microsites</li>
          <li>Gestión de inscripciones</li>
        </ul>
      </Card>
    </Section>
    <Section image="meetings-2">
      <Card
        title="Eventos virtuales"
        size="lg"
        image="meetings-1"
      >El poder de un evento cara a cara es insustituible. Sin embargo, siempre que la distancia o las circunstancias no lo permitan, asegúrese de dar la cara... ¡Geotur tiene soluciones para todo tipo de proyectos virtuales!</Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Reuniones y Eventos',
  path: '/servicios/reuniones-y-eventos',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>